import React, { useState } from "react";
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CButton,
  CForm,
  CCard,
  CCardHeader,
  CCardBody,
  CCardText,
  CImage,
  CCol,
  CRow,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilCheckCircle, cilEyedropper, cilTrash, cilWarning, cileye } from "@coreui/icons";
import Apple from "src/assets/images/app-store.png";
import Playstore from "src/assets/images/google-play.png";
import Huawei from "src/assets/images/huawei.png";
import QrCode from "src/assets/images/QRCode.png";
import { Col } from "antd";
const ErrorModal = (props) => {
  const [visible, setVisible] = useState(true);
  const handleCloseWindow = () => {
    setVisible(false);
    //const newWindow = window.open("", "_self");
    window.close();
    //newWindow.close();
  };
  return (
    <CModal visible={visible}>
      {/* <CModalHeader onClick={() => props.setVisible(false)}></CModalHeader> */}
      <CModalBody>
        <CCard className="mb-4">
          <CCardBody>
            <CCardText className="fs-3 text-center">Payment Failed</CCardText>
            <div className="text-center">
              <CIcon style={{ marginBottom: "15px", color: "#fd2f31" }} icon={cilWarning} size={"4xl"} />
            </div>
            <div>
              <p style={{ color: "#fd2f31" }} className="text-center">
                There was some technical error occured. Please try again!
              </p>
            </div>
            <div style={{ background: "#0d2235", padding: "30px" }}>
              <CRow>
                <CCol md={6}>
                  <a href="https://apps.apple.com/us/app/myclnq/id1436460772" target="_blank">
                    <CImage style={{ width: "100%" }} src={Apple} className="img-fluid mb-2" />
                  </a>

                  <a href="https://play.google.com/store/apps/details?id=com.ssivixlab.MYCLNQ&hl=en" target="_blank">
                    <CImage style={{ width: "100%" }} src={Playstore} className="img-fluid  mb-2" />
                  </a>

                  <a href="https://appgallery.huawei.com/app/C104584547" target="_blank">
                    <CImage style={{ width: "100%" }} src={Huawei} className="img-fluid" />
                  </a>
                </CCol>
                <CCol md={6}>
                  <CImage style={{ width: "100%", maxHeight: "100%", objectFit: "contain" }} src={QrCode} className="img-fluid" />
                </CCol>
              </CRow>
            </div>
          </CCardBody>
          <a style={{ cursor: "pointer", textAlign: "center" }} className="pb-4" onClick={handleCloseWindow}>
            CLOSE
          </a>
        </CCard>
      </CModalBody>
    </CModal>
  );
};

export default ErrorModal;
